<template>
    <div>
        <Button @click="$emit('click')" :class="`${breakpoints[breakpoint].hidden}`"
            :icon="icon"
            :short="true"
            emphasis="low"
            color="white"
            inlineBreakpoint="md"
            class="-mx-2 md:mx-0"
        />

        <Button @click="$emit('click')" :class="`hidden ${breakpoints[breakpoint].flex}`"
            :icon="icon"
            :text="text"
            :short="true"
            emphasis="medium"
            color="white"
            inlineBreakpoint="md"
            class="-mx-2 md:mx-0"
        />
    </div>
</template>

<script>
import { Button } from '@sportsrecruits/playbook'

export default {
    components: { Button },
    data() {
        return {
            breakpoints: {
                '2xs': { hidden: '2xs:hidden', flex: '2xs:flex'},
                'xs': { hidden: 'xs:hidden', flex: 'xs:flex'},
                'sm': { hidden: 'sm:hidden', flex: 'sm:flex'},
                'md': { hidden: 'md:hidden', flex: 'md:flex'},
                'lg': { hidden: 'lg:hidden', flex: 'lg:flex'},
                'xl': { hidden: 'xl:hidden', flex: 'xl:flex'},
                'xm': {  hidden: 'xm:hidden', flex: 'xm:flex'},
                '2xs-down': { hidden: '2xs-down:hidden', flex: '2xs-down:flex' },
                'xs-down': { hidden: 'xs-down:hidden', flex: 'xs-down:flex' },
                'md-down': { hidden: 'md-down:hidden', flex: 'md-down:flex'},
                'xm-down': { hidden: 'xm-down:hidden', flex: 'xm-down:flex'},
                'lg-down': { hidden: 'lg-down:hidden', flex: 'lg-down:flex' }
            }
        }
    },
    props: {
        text: { type: String, required: true },
        icon: { type: String, required: true },
        breakpoint: { type: String, default: 'md' }
    },
}
</script>